import React from 'react';
import { Box, Container, Typography, Grid, Avatar, Rating } from '@mui/material';
import { motion } from 'framer-motion';

const testimonials = [
    {
        name: "Sarah J.",
        role: "VERIFIED BUYER",
        text: "\"Absolutely thrilled with my purchase! The quality is outstanding, and the delivery was incredibly fast. Highly recommend this store to everyone!\"",
        rating: 5,
        avatar: "https://i.pravatar.cc/150?u=sarah"
    },
    {
        name: "Michael P.",
        role: "VERIFIED BUYER",
        text: "\"I've been a loyal customer for years, and they never disappoint. Their customer service is top-notch, and their products always exceed expectations.\"",
        rating: 5,
        avatar: "https://i.pravatar.cc/150?u=michael"
    },
    {
        name: "Emily R.",
        role: "VERIFIED BUYER",
        text: "\"Good product, but the shipping took a bit longer than expected. Overall, I'm satisfied with my order and would consider buying again.\"",
        rating: 4,
        avatar: "https://i.pravatar.cc/150?u=emily"
    },
    {
        name: "David L.",
        role: "VERIFIED BUYER",
        text: "\"The item arrived exactly as described. It's a fantastic addition to my collection. The website was easy to navigate, and checkout was smooth.\"",
        rating: 5,
        avatar: "https://i.pravatar.cc/150?u=david"
    },
    {
        name: "Jessica M.",
        role: "VERIFIED BUYER",
        text: "\"I had a question about my order, and their support team was very helpful and responsive. Great experience from start to finish!\"",
        rating: 4,
        avatar: "https://i.pravatar.cc/150?u=jessica"
    }
];

const LoveLetters = () => {
    return (
        <Box sx={{ py: 15, backgroundColor: '#F3ECE4' }}>
            <Container maxWidth="lg">
                <Box sx={{ textAlign: 'center', mb: 10 }}>
                    <Typography
                        sx={{
                            fontFamily: "'Sora', sans-serif",
                            fontSize: '0.75rem',
                            fontWeight: 600,
                            letterSpacing: '0.2em',
                            color: '#666',
                            textTransform: 'uppercase',
                            mb: 0
                        }}
                    >
                        FROM OUR COMMUNITY
                    </Typography>
                    <Typography
                        variant="h2"
                        sx={{
                            fontFamily: "'cormorantgaramond', serif",
                            fontWeight: 700,
                            fontSize: { xs: '3rem', md: '4rem' },
                            color: '#1a1a1a'
                        }}
                    >
                        Love Letters
                    </Typography>
                </Box>

                <Grid container spacing={4} justifyContent="center">
                    {testimonials.map((item, index) => (
                        <Grid item size={{ xs: 12, md: 4 }} key={index}>
                            <Box
                                component={motion.div}
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.4 }}
                                transition={{ duration: 0.8, delay: index * 0.1, ease: [0.22, 1, 0.36, 1] }}
                                sx={{
                                    backgroundColor: 'white',
                                    p: 4,
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    transition: 'all 0.4s cubic-bezier(0.22, 1, 0.36, 1)',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        transform: 'translateY(-10px) !important',
                                        boxShadow: '0 20px 40px rgba(0,0,0,0.08)'
                                    }
                                }}
                            >
                                <Box>
                                    <Rating
                                        value={item.rating}
                                        readOnly
                                        size="small"
                                        sx={{ mb: 2, color: '#A68B77' }}
                                    />
                                    <Typography
                                        sx={{
                                            fontFamily: "'cormorantgaramond', serif",
                                            fontWeight: 700,
                                            fontSize: '1.25rem',
                                            fontStyle: 'italic',
                                            lineHeight: 1.6,
                                            color: '#1a1a1a',
                                            mb: 4
                                        }}
                                    >
                                        {item.text}
                                    </Typography>
                                </Box>

                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <Avatar
                                        src={item.avatar}
                                        sx={{ width: 40, height: 40 }}
                                    />
                                    <Box>
                                        <Typography
                                            sx={{
                                                fontFamily: "'Sora', sans-serif",
                                                fontWeight: 700,
                                                fontSize: '0.8rem',
                                                color: '#1a1a1a'
                                            }}
                                        >
                                            {item.name}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontFamily: "'Sora', sans-serif",
                                                fontSize: '0.6rem',
                                                fontWeight: 600,
                                                color: '#888',
                                                letterSpacing: '0.05em'
                                            }}
                                        >
                                            {item.role}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default LoveLetters;
